/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopSourceResponse = {
    sourceId?: string;
    name?: string;
    address?: string;
    identificationNumber?: string;
    phoneNumber?: string;
    line?: string;
    email?: string;
    vatType?: ShopSourceResponse.vatType;
    note?: string;
    shopId?: string;
};
export namespace ShopSourceResponse {
    export enum vatType {
        VAT = 'VAT',
        NON_VAT = 'NON_VAT',
    }
}

